// src/plugins/auth.js
import authManager from '../services/auth-manager.service';

export default {
  install(app) {
    app.config.globalProperties.$auth = authManager;

    app.mixin({
      created() {
        if (this.handleLoginEvent) {
          authManager.addListener('loginEvent', this.handleLoginEvent);
        }
      },

      unmounted() {
        if (this.handleLoginEvent) {
          authManager.removeListener('loginEvent', this.handleLoginEvent);
        }
      }
    });
  }
};
